import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import copy from 'clipboard-copy';
import { sendClassConfirmation } from '../../services/apiServices';

const BookingSuccess = ({ homeCallback, trans, downloadInvoice, content, waiverLink, confirmMailData }) => {

    console.log("confirmationData", confirmMailData)



    const handleInvoice = async () => {
        await downloadInvoice(trans)

    };
    const [copyLink, setcopyLink] = useState(false);
    console.log(trans);


    useEffect(() => {
        const sendConfirmation = async () => {
            if (confirmMailData && Object.keys(confirmMailData).length > 0) {
                try {
                    await sendClassConfirmation(confirmMailData);
                    console.log('Confirmation email sent successfully');
                } catch (error) {
                    console.error('Error sending confirmation email:', error);
                }
            }
        };

        sendConfirmation();
    }, [confirmMailData]);




    const handleWavierLink = () => {
        copy(waiverLink);
        setcopyLink(true);
    }
    return (
        <>
            <div className='p-0 p-md-5 d-flex align-items-center justify-content-center h-100 bg-secondary text-dark bg-opacity-10'>
                <div className='row w-100 justify-content-center'>
                    <div className='col-12 col-md-5'>
                        <MDBCard className='shadow-4'>
                            <MDBCardBody>
                                <div className=' d-flex align-items-center justify-content-center'>
                                    <label class="field">
                                        <input class="field__checkbox" type="checkbox" checked />
                                        <span class="field__label">
                                            <svg class="check" viewBox="0 0 64 64" aria-hidden="true">
                                                <g transform="translate(32,32)">
                                                    <g stroke-linecap="round" stroke-width="3">
                                                        <polyline class="check__stroke-offset check__stroke-offset--1" stroke="var(--purple)" points="-30 -30,-42 -42" stroke-dasharray="17 17" stroke-dashoffset="17" />
                                                        <polyline class="check__stroke-offset check__stroke-offset--2" stroke="var(--primary)" points="38 -38,54 -54" stroke-dasharray="22.63 22.63" stroke-dashoffset="22.63" />
                                                        <polyline class="check__stroke-offset check__stroke-offset--3" stroke="var(--green)" points="-28 28,-40 40" stroke-dasharray="17 17" stroke-dashoffset="17" />
                                                        <polyline class="check__stroke-offset check__stroke-offset--4" stroke="var(--red)" points="32 32,44 44" stroke-dasharray="17 17" stroke-dashoffset="17" />
                                                    </g>
                                                    <g>
                                                        <circle class="check__move-fade check__move-fade--1" fill="var(--red)" r="3" cx="4" cy="-44" opacity="0" />
                                                        <circle class="check__move-fade check__move-fade--2" fill="var(--primary)" r="3" cx="-44" cy="-8" opacity="0" />
                                                        <circle class="check__move-fade check__move-fade--3" fill="var(--green)" r="3" cx="52" cy="12" opacity="0" />
                                                        <circle class="check__move-fade check__move-fade--4" fill="var(--purple)" r="2" cx="-2" cy="40" opacity="0" />
                                                        <circle class="check__move-fade check__move-fade--5" fill="var(--primary)" r="3" cx="-12" cy="46" opacity="0" />
                                                    </g>
                                                    <g class="check__scale-out" fill="none" stroke="var(--check-outline)" stroke-width="2">
                                                        <circle r="30" />
                                                        <polygon points="-10 -4,-16 2,-4 14,16 -6,10 -12,-4 2" />
                                                    </g>
                                                    <g class="check__fade" opacity="0">
                                                        <circle class="check__scale-in check__scale-in--1" fill="var(--check-bubble)" r="30.9" />
                                                        <circle class="check__scale-in check__scale-in--2" fill="var(--primary)" r="31" />
                                                        <polygon class="check__scale-in check__scale-in--3" fill="var(--white)" stroke="var(--primary)" stroke-width="2" points="-10 -4,-16 2,-4 14,16 -6,10 -12,-4 2" />
                                                    </g>
                                                </g>
                                            </svg>

                                            <span class="field__sr-only">Check circle</span>
                                        </span>
                                    </label>
                                </div>

                                {trans?.razorpay_order && trans?.razorpay_order?.razorpay_order_id && <p className='text-center text-secondary mb-1'>Booking ID: {trans?.razorpay_order && trans?.razorpay_order?.razorpay_order_id ? (trans?.razorpay_order?.razorpay_order_id) : "Unknown id"}</p>}
                                <MDBCardText className='text-center fw-bold fs-6'>
                                    {content ? content : "Your class has been booked successfully."}
                                </MDBCardText>
                                <div className='d-flex mx-3 mb-3'>
                                    <MDBBtn className='text-capitalize w-50 me-2' onClick={handleInvoice}>Download Invoice</MDBBtn>
                                    {waiverLink && <MDBBtn className='text-capitalize w-50 me-2' onClick={handleWavierLink}>Wavier Link</MDBBtn>}
                                    <MDBBtn className='text-capitalize w-50' onClick={homeCallback}>Home</MDBBtn>
                                </div>

                            </MDBCardBody>
                        </MDBCard>
                    </div>
                </div>
            </div >
            <MDBAlert
                color='success'
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={copyLink}
                onClose={() => setcopyLink(false)}
            >Link copied to clipboard!
            </MDBAlert>
        </>
    )
}

export default BookingSuccess
